import { UseFormReturnType } from '@mantine/form';
import { EvidenceFieldSelect } from 'components/selects/EvidenceFieldSelect';
import { IFormInputSpec } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Sub-form for deviceEvidenceField input properties.
 */
export default function DeviceEvidenceFieldInputPropertiesSubForm({
  form,
}: {
  form: UseFormReturnType<IFormInputSpec>;
}) {
  return (
    <EvidenceFieldSelect
      applicability="devices"
      size="sm"
      label="Výber evidenčného poľa"
      searchable
      required
      {...form.getInputProps('evidenceFieldId')}
    />
  );
}
